import React from 'react'
import { AnchorsOfFormsWrappers } from '@constants/forms'
import { PartnerForm } from '@shared/components/forms/partner'
import { Section } from '@shared/components/section'
import { partnerFormSummary } from 'screens/partners/sections/partner-form-section/data'

import styles from './style.module.scss'

export const View = () => (
	<Section id={AnchorsOfFormsWrappers.partner} fullWidth className={styles.fluidWrapper}>
		<Section className={styles.wrapper}>
			<div className={styles.summary}>
				<h2 className={styles.title}>Зарабатывайте вместе с&nbsp;нами</h2>
				<div className={styles.summaryContent}>
					{partnerFormSummary.map(({ Icon, content }, i) => (
						<div key={i} className={styles.summaryItem}>
							<Icon className={styles.summaryItemIcon} />
							{content}
						</div>
					))}
				</div>
			</div>
			<div className={styles.formWrapper}>
				<PartnerForm />
			</div>
		</Section>
	</Section>
)
